import React, { useState, useEffect } from 'react';
import { Grid, Alert, Snackbar, CircularProgress, Backdrop } from '@mui/material';
import SearchFilter from './DS/SearchFilter';
import CspTable from './DS/CspTable';
import SideMenu from './DS/category/SideMenu';
import { DsUserList, DsUserUpdate } from 'API/UserList/DsuserList';
import SubCard from 'ui-component/cards/SubCard';

const Dsindex = () => {
  const [filter, setFilter] = useState({
    search: '',
    category: '',
    user_type: 'DS'
  });
  const [ValueEdit, setValueEdit] = useState(false);
  const [Isloading, setIsloading] = useState(false);
  const [UserList, setUserList] = useState([]);
  const [SuccessMsg, setSuccessMsg] = useState(false);
  const [ErrorMsg, setErrorMsg] = useState(false);
  const [postData, setPostData] = useState({});
  const [page, setPage] = useState(0); // Current page (starts from 0)
  const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page

  const handleStep = (values) => {
    setPostData({ ...postData, ...values });
  };

  const [selectedUser, setSelectedUser] = useState(null);

  const handleView = (user) => {
    setSelectedUser(user);
    setValueEdit(true);
  };
  const handlePostChange = (e) => {
    const { name, value } = e.target;
    setPostData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFilter((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleClear = () => {
    setFilter({ search: '', category: '', user_type: 'DS' });
    DsUserList(page + 1, rowsPerPage, setIsloading, setUserList, setErrorMsg, { search: '', category: '', user_type: 'DS' });
  };

  const handlePostData = (values) => {
    DsUserUpdate({ ...postData, ...values }, setIsloading, setSuccessMsg, setErrorMsg, setValueEdit, refunction);
  };

  const handleSubmit = (values) => {

    handlePostData(values);
  };

  const refunction = () => {
    setUserList([]);
    DsUserList(page + 1, rowsPerPage, setIsloading, setUserList, setErrorMsg, filter);
  };

  useEffect(() => {
    setUserList([]);
    DsUserList(page + 1, rowsPerPage, setIsloading, setUserList, setErrorMsg, filter);
  }, [filter.search, filter.user_type, page, rowsPerPage]);

  return (
    <>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={Isloading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={ErrorMsg}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={() => setErrorMsg(false)}
      >
        <Alert onClose={() => setErrorMsg(false)} severity="error" variant="filled" sx={{ width: '100%' }}>
          {ErrorMsg}
        </Alert>
      </Snackbar>
      <Snackbar
        open={SuccessMsg}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={() => setSuccessMsg(false)}
      >
        <Alert onClose={() => setSuccessMsg(false)} severity="success" variant="filled" sx={{ width: '100%' }}>
          {SuccessMsg}
        </Alert>
      </Snackbar>
      <Grid>
        <Grid item xs={12}>
          {ValueEdit ? (
            <>
              <SideMenu
                setValueEdit={setValueEdit}
                UserList={selectedUser}
                handleStep={handleStep}
                handlePostChange={handlePostChange}
                handleSubmit={handleSubmit}
                postData={postData}
              />
            </>
          ) : (
            <>
            <SubCard title='Ds List'>
              <SearchFilter filter={filter} handleChange={handleChange} handleClear={handleClear} />
              <CspTable
                filter={filter}
                ValueEdit={ValueEdit}
                setValueEdit={setValueEdit}
                UserList={UserList}
                Isloading={Isloading}
                refunction={refunction}
                setRowsPerPage={setRowsPerPage}
                setPage={setPage}
                handleView={handleView}
              />
              </SubCard>
            </>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default Dsindex;
